(() => {
  if (window.aggCartEnhancer) return;
  window.aggCartEnhancer = { initialized: true };
  const miniSelector = '.theme-ajax-cart.is-mini-cart';
  let resizeFrame = 0;
  let keyboardOpen = null;
  let quantityFocus = null;

  function attemptKey(code) { return `aggCartAttempt:${code}`; }
  function readAttempt(code) {
    try { return sessionStorage.getItem(attemptKey(code)); } catch (_) { return null; }
  }
  function clearAttempt(code) {
    try { sessionStorage.removeItem(attemptKey(code)); } catch (_) {}
  }
  function syncPromo(scope) {
    scope.querySelectorAll('[data-agg-promo]').forEach(promo => {
      const attempt = readAttempt(promo.dataset.code);
      if (promo.dataset.applied === 'true' || (attempt && attempt !== promo.dataset.signature)) {
        clearAttempt(promo.dataset.code);
      } else if (attempt) {
        const status = promo.querySelector('[data-agg-promo-status]');
        if (status.textContent !== promo.dataset.failure) status.textContent = promo.dataset.failure;
      }
    });
  }
  function fitMini() {
    resizeFrame = 0;
    document.querySelectorAll(miniSelector).forEach((mini, index) => {
      const trigger = mini.closest('[data-ajax-cart-trigger]');
      if (!trigger) return;
      // Flex can bind hover after its initial Ajax view; remove only cart-trigger hover.
      window.jQuery?.(trigger).off('mouseenter mouseleave');
      mini.setAttribute('role', 'dialog');
      mini.setAttribute('aria-label', 'Shopping cart');
      const link = trigger.querySelector(':scope > a');
      const isOpen = trigger.classList.contains('show-mini-cart');
      if (link) {
        link.setAttribute('aria-expanded', String(isOpen));
        link.setAttribute('aria-haspopup', 'dialog');
      }
      if (trigger.getBoundingClientRect().width) {
        const viewportWidth = document.documentElement.clientWidth;
        mini.style.setProperty('--agg-cart-viewport-width', `${viewportWidth}px`);
        mini.style.setProperty('--agg-cart-inline-shift', '0px');
        const rect = mini.getBoundingClientRect();
        const shift = Math.max(0, 12 - rect.left) + Math.min(0, viewportWidth - 12 - rect.right);
        mini.style.setProperty('--agg-cart-inline-shift', `${shift}px`);
        const viewportHeight = window.visualViewport?.height || window.innerHeight;
        const available = Math.max(160, viewportHeight - Math.max(0, mini.getBoundingClientRect().top) - 12);
        mini.style.setProperty('--agg-cart-available-height', `${available}px`);
      }
      mini.querySelectorAll('.product-quantity-box').forEach(box => {
        const input = box.querySelector('.quantity-input');
        const label = box.querySelector('label');
        if (input && label) {
          const id = `agg-mini-${index}-${box.closest('[data-cart-item]').dataset.cartItem.replace(/[^a-zA-Z0-9_-]/g, '-')}`;
          if (input.id !== id) input.id = id;
          if (label.htmlFor !== id) label.htmlFor = id;
        }
      });
      if (keyboardOpen === trigger && isOpen) {
        const close = mini.querySelector('.ajax-cart__close-icon');
        if (close) { close.focus({ preventScroll: true }); keyboardOpen = null; }
      }
    });
  }
  function scheduleFit() {
    if (!resizeFrame) resizeFrame = requestAnimationFrame(fitMini);
  }
  function rememberQuantity(target) {
    const control = target.closest('[data-update-quantity], .quantity-input');
    const root = control?.closest(miniSelector + ', .agg-cart-page .cart__form');
    const item = control?.closest('[data-cart-item]');
    if (root && item) quantityFocus = { root, itemKey: item.dataset.cartItem, control, direction: control.dataset.updateQuantity };
  }
  function restoreQuantity(root) {
    if (!quantityFocus || quantityFocus.root !== root || (quantityFocus.control.isConnected && !quantityFocus.control.disabled)) return;
    const pending = quantityFocus;
    quantityFocus = null;
    if (document.activeElement !== document.body) return;
    const item = root.querySelector(`[data-cart-item="${CSS.escape(pending.itemKey)}"]`);
    const button = pending.direction && item?.querySelector(`[data-update-quantity="${pending.direction}"]`);
    const control = button && !button.disabled ? button : item?.querySelector('.quantity-input');
    control?.focus({ preventScroll: true });
  }
  function closeMini(trigger, restoreFocus) {
    if (!trigger) return;
    trigger.classList.remove('show-mini-cart');
    if (restoreFocus) trigger.querySelector(':scope > a')?.focus({ preventScroll: true });
  }
  function init() {
    document.addEventListener('click', event => rememberQuantity(event.target), true);
    document.addEventListener('change', event => rememberQuantity(event.target), true);
    document.addEventListener('click', event => {
      const apply = event.target.closest('[data-agg-promo-apply]');
      if (apply) {
        const promo = apply.closest('[data-agg-promo]');
        try { sessionStorage.setItem(attemptKey(promo.dataset.code), promo.dataset.signature); } catch (_) {}
      }
      const trigger = event.target.closest('[data-ajax-cart-trigger]');
      if (trigger && !event.target.closest(miniSelector) && trigger.querySelector(miniSelector)) {
        event.preventDefault();
        trigger.classList.add('show-mini-cart');
        if (event.detail === 0) keyboardOpen = trigger;
        scheduleFit();
      } else if (event.target.closest('[data-ajax-cart-close]')) {
        closeMini(trigger, true);
      } else if (!trigger) {
        document.querySelectorAll('[data-ajax-cart-trigger].show-mini-cart').forEach(item => closeMini(item, false));
      }
    });
    document.addEventListener('keydown', event => {
      const trigger = event.target.closest('[data-ajax-cart-trigger]');
      if (event.key === 'Escape') {
        const open = document.querySelectorAll('[data-ajax-cart-trigger].show-mini-cart');
        if (open.length) event.preventDefault();
        open.forEach(item => closeMini(item, item.getBoundingClientRect().width > 0));
      } else if (event.key === ' ' && event.target.matches('[data-ajax-cart-trigger] > a')) {
        event.preventDefault();
        event.target.click();
      }
    });
    document.querySelectorAll(miniSelector).forEach(mini => {
      const trigger = mini.closest('[data-ajax-cart-trigger]');
      new MutationObserver(records => {
        if (records.some(record => record.type === 'childList' && [...record.addedNodes].some(node => node.nodeType === 1))) syncPromo(mini);
        restoreQuantity(mini);
        scheduleFit();
      }).observe(trigger, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    });
    const cartForm = document.querySelector('.agg-cart-page .cart__form');
    if (cartForm) {
      new MutationObserver(records => {
        if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-agg-promo], .cart__subtotal-container') || node.querySelector('[data-agg-promo]'))))) syncPromo(cartForm);
        restoreQuantity(cartForm);
      }).observe(cartForm, { childList: true, subtree: true });
    }
    window.addEventListener('resize', scheduleFit, { passive: true });
    // Native mobile Add to Cart scrolls while the smart header returns.
    window.addEventListener('scroll', () => {
      if (document.querySelector('#mobile-header [data-ajax-cart-trigger].show-mini-cart')) scheduleFit();
    }, { passive: true });
    document.addEventListener('transitionend', event => {
      if (event.target.matches('#mobile-header')) scheduleFit();
    });
    window.visualViewport?.addEventListener('resize', scheduleFit, { passive: true });
    syncPromo(document);
    scheduleFit();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
